module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n                " + _vm._s(_vm.flashMessage) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Trip Code")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("\n                    " + _vm._s(_vm.trip.tripGroupCode) + "\n                  ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_vm._v("\n                        >\n                        "), _c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.getFilteredLocationList(
      index
    )), function(item, itemIndex) {
      return _c('option', {
        key: itemIndex,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                          " + _vm._s(item.siteName) + "\n                        ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                          HCV Operation Manager is a required field\n                        ")])])], 1), _vm._v(" "), (index === _vm.locations.length - 2) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField('locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]) : _vm._e(), _vm._v(" "), (index > 1 && index < _vm.locations.length - 1) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, 'locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })]) : _vm._e()], 1)])
  }), 0), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                  Cancel\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateSubTrips
    }
  }, [_vm._v("\n                Update\n              ")])], 1)], 1)])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createRoute()
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Update Subtrips")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87672c7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip-group/Update-Locations.vue
// module id = 2003
// module chunks = 1